import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { LayoutModeType } from '@osos/shared/types';
import { FONT_BASE_SIZE } from '../const';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  constructor(@Inject(DOCUMENT) public document: Document) {}

  changeLayoutMode(layoutMode: LayoutModeType = 'light'): void {
    if (layoutMode === 'dark') {
      this.document.documentElement.classList.add('dark-mode');
    } else {
      this.document.documentElement.classList.remove('dark-mode');
    }
  }
  changeFontSize(fontSize = FONT_BASE_SIZE, unit = 'px'): void {
    this.document.documentElement.style.fontSize = `${fontSize}${unit}`;
    this.document.documentElement.style.setProperty(
      '--font-size',
      `${fontSize}${unit}`,
    );
  }
}
